import { Text } from '@intigral/shared';
import { iButtonCarouselComponent } from '../../interface/iProviders';
import { Carousel2 } from '../Carousel2';
import { ListItem } from './ListItem';

/**
 * Provier carousel
 * @param {Props} props
 * @typedef Props
 * @prop {string} id - id of the carousel
 * @prop {string} title - title text for the carousel
 * @prop {object} sliderSettings - React slider settings
 * @prop {object[]} list - list of carousel items
 * @prop {()=>void} [itemClickCallback] - callback on item click
 * @prop {boolean} textOnly - To show only text or image as button slider
 * @prop {'ltr' | 'rtl'} direction - Arabic or english slider direction
 */
export const ButtonCarousel = ({
    id,
    title,
    sliderSettings,
    list,
    itemClickCallback,
    textOnly = false,
    direction = 'ltr',
    carousel,
}: iButtonCarouselComponent) => {
    // console.log('provider carousel list', list);
    return (
        <div
            className="container full-width providers-gallery"
            id={carousel?.title_resource_key}
            data-test-id={carousel?.title_resource_key}
        >
            <Text
                as="h2"
                variant="h2"
                alignment="start"
                margin={{ default: '2x', md: '3x' }}
                size={{ default: '18', md: '28' }}
            >
                {title}
            </Text>
            <div dir={direction} id={id}>
                <Carousel2 swiperSettings={sliderSettings}>
                    {(list ?? [])
                        .filter((item) => item.show)
                        .map((item, idx) => {
                            return (
                                <ListItem
                                    item={item}
                                    key={idx}
                                    itemClickCallback={itemClickCallback}
                                    // textOnly={textOnly}
                                />
                            );
                        })}
                </Carousel2>
            </div>
        </div>
    );
};
